import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ComprehensiveUserAgreement } from '../components/Legal';

const HILLS_BG_IMAGE =
  'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxyb2xsaW5nJTIwZ3JlZW4lMjBoaWxscyUyMGJsdWUlMjBza3l8ZW58MHx8fHwxNzc2ODMxNDgwfDA&ixlib=rb-4.1.0&q=85';

const RegisterPage = ({ onSwitch }) => {
  const { register } = useAuth();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [isEighteenOrOlder, setIsEighteenOrOlder] = useState(false);
  const [showAgreement, setShowAgreement] = useState(true);
  const [agreementData, setAgreementData] = useState(null);

  const handleAgreementAccept = (data) => {
    setAgreementData(data);
    setShowAgreement(false);
  };
  const handleAgreementDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreementData) { setError('You must accept the User Agreement to continue'); return; }
    if (!isEighteenOrOlder) { setError('You must confirm that you are 18 years of age or older to register'); return; }
    setError('');
    setLoading(true);
    try {
      await register(email, username, password, isEighteenOrOlder, rememberMe);
    } catch (err) {
      if (err.message === 'Network error') {
        setError('Unable to reach the server. Please check your internet connection and try again.');
      } else {
        setError(err.message);
      }
    }
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    if (!agreementData) { setError('You must accept the User Agreement before signing in'); return; }
    if (!isEighteenOrOlder) { setError('You must confirm that you are 18 years of age or older'); return; }
    const redirectUrl = window.location.origin;
    sessionStorage.setItem('agreementData', JSON.stringify(agreementData));
    sessionStorage.setItem('isEighteenOrOlder', 'true');
    try {
      localStorage.setItem('oauth_pending', Date.now().toString());
      localStorage.setItem('remember_me', rememberMe ? 'true' : 'false');
    } catch (e) { /* ignore */ }
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (showAgreement) {
    return <ComprehensiveUserAgreement onAccept={handleAgreementAccept} onDecline={handleAgreementDecline} />;
  }

  return (
    <div
      data-testid="register-page"
      className="register-split"
      style={{
        minHeight: '100vh',
        display: 'grid',
        gridTemplateColumns: '1fr',
        background: 'linear-gradient(180deg, #C4B5FD 0%, #E0F2FE 20%, #FEF9C3 50%, #BBF7D0 100%)',
      }}
    >
      <aside
        className="hidden md:flex"
        style={{
          position: 'relative',
          minHeight: '100vh',
          backgroundImage: `linear-gradient(180deg, rgba(186, 230, 253, 0.72) 0%, rgba(254, 249, 195, 0.45) 45%, rgba(134, 239, 172, 0.55) 100%), url("${HILLS_BG_IMAGE}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '48px',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h1 style={{
            fontFamily: 'Outfit, "IBM Plex Sans", sans-serif',
            fontSize: '3rem', fontWeight: 900, letterSpacing: '-0.02em',
            color: '#0F172A', margin: 0,
            textShadow: '0 2px 12px rgba(255,255,255,0.7)',
          }}>InfoPilot</h1>
          <p style={{
            color: '#0F172A', fontSize: '1.05rem', marginTop: 8, maxWidth: 380,
            fontWeight: 500,
            textShadow: '0 1px 6px rgba(255,255,255,0.6)',
          }}>
            Join a calm, natural search workspace. Your gateway to protocols, maps, and social discovery — under open skies.
          </p>
        </div>
        <div style={{
          background: 'rgba(255, 255, 255, 0.92)', backdropFilter: 'blur(14px)',
          borderRadius: 16, padding: '18px 22px',
          border: '1px solid rgba(16, 185, 129, 0.32)',
          boxShadow: '0 8px 24px rgba(14, 165, 233, 0.15)', maxWidth: 440,
        }}>
          <div style={{ fontSize: '0.75rem', fontWeight: 700, color: '#047857', letterSpacing: '0.15em' }}>
            JOIN THE NETWORK
          </div>
          <div style={{ fontFamily: 'Outfit', fontSize: '1.4rem', fontWeight: 700, color: '#0F172A', marginTop: 4 }}>
            Free. Natural. Made for curious minds.
          </div>
        </div>
      </aside>

      <main style={{
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '32px 20px',
      }}>
        <div style={{
          width: '100%', maxWidth: 460,
          background: '#ffffff', borderRadius: 20,
          padding: '28px 24px',
          border: '1px solid rgba(14, 165, 233, 0.25)',
          boxShadow: '0 20px 60px rgba(14, 165, 233, 0.12)',
        }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <h2 style={{
              fontFamily: 'Outfit, "IBM Plex Sans", sans-serif',
              fontSize: '1.7rem', fontWeight: 800, margin: 0, color: '#0F172A',
            }}>Create your account</h2>
            <p style={{ color: '#475569', fontSize: '0.9rem', margin: '6px 0 0' }}>
              World Wide Web Information Exchange
            </p>
          </div>

          <div style={{
            background: 'rgba(16, 185, 129, 0.10)',
            border: '1px solid rgba(16, 185, 129, 0.35)',
            borderRadius: 10,
            padding: '10px 14px',
            marginBottom: 14,
            textAlign: 'center',
          }}>
            <span style={{ color: '#047857', fontSize: '0.85rem', fontWeight: 600 }}>
              ✓ Terms Accepted · ✓ Privacy Acknowledged
            </span>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {error && <div style={{ color: '#B91C1C', textAlign: 'center', fontSize: '0.9rem', marginBottom: 4 }}>{error}</div>}
            <input
              type="text" placeholder="Username" value={username}
              onChange={(e) => setUsername(e.target.value)} required
              data-testid="register-username-input"
              style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1px solid #E2E8F0', background: '#FDFBF7', color: '#0F172A', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
            />
            <input
              type="email" placeholder="Email" value={email}
              onChange={(e) => setEmail(e.target.value)} required
              data-testid="register-email-input"
              style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1px solid #E2E8F0', background: '#FDFBF7', color: '#0F172A', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
            />
            <input
              type="password" placeholder="Password" value={password}
              onChange={(e) => setPassword(e.target.value)} required
              data-testid="register-password-input"
              style={{ width: '100%', padding: '12px 16px', borderRadius: 12, border: '1px solid #E2E8F0', background: '#FDFBF7', color: '#0F172A', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
            />

            {/* Age Verification */}
            <div style={{
              background: isEighteenOrOlder ? 'rgba(16, 185, 129, 0.10)' : 'rgba(14, 165, 233, 0.10)',
              border: `2px solid ${isEighteenOrOlder ? 'rgba(16, 185, 129, 0.5)' : 'rgba(14, 165, 233, 0.4)'}`,
              borderRadius: 12, padding: '14px', marginTop: 4,
              transition: 'all 0.3s',
            }}>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 12, cursor: 'pointer' }}>
                <div
                  style={{
                    width: 28, height: 28, minWidth: 28, borderRadius: 6, marginTop: 2,
                    border: isEighteenOrOlder ? '2px solid #10B981' : '2px solid #0EA5E9',
                    background: isEighteenOrOlder ? '#10B981' : '#ffffff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.2s',
                  }}
                  onClick={(e) => { e.preventDefault(); setIsEighteenOrOlder(!isEighteenOrOlder); }}
                >
                  {isEighteenOrOlder && (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </div>
                <input
                  type="checkbox" checked={isEighteenOrOlder}
                  onChange={(e) => setIsEighteenOrOlder(e.target.checked)}
                  data-testid="age-verification-checkbox"
                  style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
                />
                <div>
                  <span style={{
                    color: isEighteenOrOlder ? '#047857' : '#0369A1',
                    fontWeight: 700, fontSize: '0.95rem', display: 'block', marginBottom: 4,
                  }}>
                    {isEighteenOrOlder ? 'Age Verified' : 'Age Verification Required'}
                  </span>
                  <span style={{ color: '#475569', fontSize: '0.85rem', lineHeight: 1.5 }}>
                    I confirm that I am <strong style={{ color: '#0F172A' }}>18 years of age or older</strong> and
                    I understand this platform is intended for adult users.
                  </span>
                </div>
              </label>
            </div>

            {/* Keep me logged in */}
            <div style={{
              padding: '14px 16px',
              background: rememberMe ? 'rgba(16, 185, 129, 0.12)' : '#F8FAFC',
              border: rememberMe ? '2px solid #10B981' : '2px solid #E2E8F0',
              borderRadius: 12,
            }}>
              <label style={{
                display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer',
                fontSize: '0.95rem', color: rememberMe ? '#047857' : '#334155', fontWeight: 600,
              }}>
                <div
                  style={{
                    width: 28, height: 28, minWidth: 28, borderRadius: 6,
                    border: rememberMe ? '2px solid #10B981' : '2px solid #CBD5E1',
                    background: rememberMe ? '#10B981' : '#ffffff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.2s',
                  }}
                  onClick={(e) => { e.preventDefault(); setRememberMe(!rememberMe); }}
                >
                  {rememberMe && (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </div>
                <input
                  type="checkbox" checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  data-testid="register-remember-me-checkbox"
                  style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
                />
                <span>Keep me logged in for 1 month!</span>
              </label>
            </div>

            <button
              type="submit" disabled={loading || !isEighteenOrOlder}
              data-testid="register-submit-btn"
              style={{
                width: '100%', padding: '14px', borderRadius: 999, border: 'none',
                background: 'linear-gradient(135deg, #10B981, #059669)',
                color: '#ffffff', fontSize: '1rem', fontWeight: 800,
                cursor: (!isEighteenOrOlder || loading) ? 'not-allowed' : 'pointer',
                opacity: (!isEighteenOrOlder || loading) ? 0.55 : 1,
                boxShadow: '0 8px 20px rgba(16, 185, 129, 0.35)',
              }}
            >
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </form>

          <div style={{ display: 'flex', alignItems: 'center', margin: '16px 0' }}>
            <div style={{ flex: 1, height: 1, background: '#E2E8F0' }} />
            <span style={{ padding: '0 12px', color: '#94A3B8', fontSize: '0.82rem' }}>or</span>
            <div style={{ flex: 1, height: 1, background: '#E2E8F0' }} />
          </div>

          <button
            onClick={handleGoogleLogin} disabled={!isEighteenOrOlder}
            data-testid="google-register-btn"
            style={{
              width: '100%', padding: '12px', borderRadius: 12,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              background: '#ffffff', border: '1px solid #E2E8F0',
              color: '#0F172A', fontSize: '0.95rem', fontWeight: 500,
              cursor: !isEighteenOrOlder ? 'not-allowed' : 'pointer',
              opacity: !isEighteenOrOlder ? 0.55 : 1,
            }}
          >
            <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: 18 }} />
            Continue with Google
          </button>

          <div style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem', color: '#64748B' }}>
            Already have an account?{' '}
            <a href="#" onClick={(e) => { e.preventDefault(); onSwitch(); }}
              data-testid="switch-to-login"
              style={{ color: '#047857', textDecoration: 'none', fontWeight: 700 }}>
              Sign In
            </a>
          </div>
        </div>
      </main>

      <style>{`
        @media (min-width: 768px) {
          .register-split { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
    </div>
  );
};

export default RegisterPage;
